<nb-card class="asset-photo-carousel-card">
  <nb-card-header class="header">
    <div class="header-left-icons"></div>
    <span class="title">{{ asset?.label }}</span>
    <span class="close-btn" (click)="close()">
      <i class="fa-light fa-x"></i>
    </span>
  </nb-card-header>

  <input #photoFileInput type="file" accept="image/*" style="display: none" (change)="onPhotoFileSelected($event)" />

  <nb-card-body class="body">
    @if (currentPicture) {
      <div class="carousel-main">
        @if (currentIndex > 0) {
          <button class="carousel-nav carousel-nav-left" (click)="prevPhoto()">
            <i class="fa-light fa-chevron-left"></i>
          </button>
        }
        @if (failedPictureIds.has(currentPicture.id)) {
          <div class="carousel-img-error">
            <i class="fa-light fa-image"></i>
          </div>
        } @else {
          <img
            [src]="currentPicture.picture || getThumbnailUrl(currentPicture)"
            [alt]="asset?.label"
            class="carousel-main-img"
            (error)="onImageError($event, currentPicture)"
          />
        }
        @if (currentIndex < pictures.length - 1) {
          <button class="carousel-nav carousel-nav-right" (click)="nextPhoto()">
            <i class="fa-light fa-chevron-right"></i>
          </button>
        }
      </div>

      <div class="carousel-delete-row">
        <button class="carousel-add-btn" (click)="triggerPhotoUpload()" [disabled]="isUploadingPhoto" [title]="'asset_form_drawer.synthese.add_photo' | translate">
          <i class="fa-light fa-plus"></i>
        </button>
        <button class="carousel-delete-btn" (click)="deleteCurrentPhoto()" [disabled]="isUploadingPhoto" [attr.aria-label]="'Delete' | translate">
          <i class="fa-regular fa-trash-can"></i>
        </button>
      </div>
    } @else {
      <div class="carousel-empty">
        <button class="carousel-add-photo-btn" (click)="triggerPhotoUpload()" [disabled]="isUploadingPhoto">
          <i class="fa-regular fa-camera"></i>
          {{ "asset_form_drawer.synthese.add_photo" | translate }}
        </button>
      </div>
    }

  </nb-card-body>

  <nb-card-footer class="footer">
    <div class="carousel-thumbnails">
      @for (picture of pictures; track picture.id; let i = $index) {
        <div class="carousel-thumb" [class.active]="i === currentIndex" (click)="selectPhoto(i)">
          @if (failedPictureIds.has(picture.id)) {
            <div class="carousel-thumb-error"><i class="fa-light fa-image"></i></div>
          } @else {
            <img
              [src]="getThumbnailUrl(picture) || picture.picture"
              [alt]="asset?.label"
              (error)="onImageError($event, picture)"
            />
          }
        </div>
      }
    </div>
  </nb-card-footer>
</nb-card>
